import { useCallback, useEffect } from "react";
import { useInterval } from "./useInterval";
import { useAppDispatch } from "@redux/hooks";
import { showVersionMismatch } from "@shared-kernel/application/use-cases/show-version-mismatch/show-version-mismatch";

const VERSION_CHECK_INTERVAL = 60 * 1000; // 1 minute

export const updateVersionAndReload = async () => {
  try {
    const res = await fetch("/version.txt", {
      headers: { "Cache-Control": "no-cache" },
    });
    const version = await res.text();
    localStorage.setItem("appVersion", version);
    window.location.reload();
  } catch (error) {
    console.error("Failed to fetch version:", error);
    window.location.reload(); // Reload anyway as fallback
  }
};

export const useVersionCheck = () => {
  const dispatch = useAppDispatch();

  // Set current version on app load
  useEffect(() => {
    fetch("/version.txt", {
      headers: { "Cache-Control": "no-cache" },
    })
      .then(res => res.text())
      .then(version => localStorage.setItem("appVersion", version))
      .catch(console.error);
  }, []);

  const checkVersion = useCallback(async () => {
    try {
      const res = await fetch("/version.txt", {
        headers: { "Cache-Control": "no-cache" },
      });
      const newVersion = await res.text();
      const storedVersion = localStorage.getItem("appVersion");

      if (newVersion !== storedVersion) {
        dispatch(showVersionMismatch());
      }
    } catch (error) {
      console.error("Version check failed:", error);
    }
  }, [dispatch]);

  useInterval(checkVersion, VERSION_CHECK_INTERVAL);
};
